module.exports = __webpack_public_path__ + "static/usagiwarrior-6ba79281c334c3c81d8f261c051ade29.mp4";